import * as React from "react";
import {Checkbox, Icon, Table} from "semantic-ui-react";
import Button from "../../../components/Button";
import DeleteButton from "../../../components/DeleteButton";
import {formatDate} from "../../../components/Table/dataHandler/Utils";
import {FaqDto} from "../../../services/Client";
import {
    DraggableProvided,
    DraggableStateSnapshot,
} from "react-beautiful-dnd";
import HATEOASClient from "../../../services/HATEOASClient";
import {CheckboxProps} from "semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox";

interface IFaqRowProps {
    faq: FaqDto;
    t: reactI18Next.TranslationFunction;
    provided: DraggableProvided;
    snapshot: DraggableStateSnapshot;
    canEdit: boolean;
    client: HATEOASClient;
    onDelete: () => void;
    onUpdate: () => void;
    onUpdateActive: (faqDto: FaqDto, active: boolean) => void;
}

interface IFaqRowState {
    answerOpen: boolean;
}

class FaqRow extends React.Component<IFaqRowProps, IFaqRowState> {
    constructor(props: IFaqRowProps) {
        super(props);
        this.state = {
            answerOpen: false,
        };
    }

    render() {
        const {
            faq,
            t,
            provided,
            snapshot,
            canEdit,
            client,
            onDelete,
            onUpdate,
            onUpdateActive
        } = this.props;

        return (
            <tr
                key={faq.sequence}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                    userSelect: "none",
                    background: snapshot.isDragging ? "#880505bd" : "initial",
                    ...provided.draggableProps.style
                }}
            >
                <Table.Cell width='10' textAlign={'left'} className='faq-text-cell'>
                    <div>{faq.question}</div>
                    <div onClick={() => this.setState({answerOpen: !this.state.answerOpen})}>
                        {this.state.answerOpen
                            ? faq.answer
                            : this.props.t("FAQ:ANSWER")
                        }
                        <div><Icon name={this.state.answerOpen ? "eye slash" : "eye"} size={"big"} /></div>
                    </div>
                </Table.Cell>
                <Table.Cell width='1'>
                    <Checkbox
                        disabled={!canEdit}
                        toggle={true}
                        checked={faq.active}
                        onChange={(_: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => onUpdateActive(faq, !!data.checked)}
                    />
                </Table.Cell>
                <Table.Cell width='1'>
                    {faq.metadata && faq.metadata.createdTimestamp ? formatDate(faq.metadata.createdTimestamp) : "-"}
                </Table.Cell>
                <Table.Cell width='1' style={{minWidth: 120}}>
                    {faq.metadata && faq.metadata.changedTimestamp && faq.metadata.changedTimestamp !== faq.metadata.createdTimestamp
                        ? formatDate(faq.metadata.changedTimestamp) : "-"}
                </Table.Cell>
                <Table.Cell width='2'>
                    <div className='display--flex flex-direction--column justify-content--center'>
                        {client.PATCH_faq(faq).canExecute() &&
                            <Button
                                label={t("FAQ:UPDATE")}
                                labelPosition={"after"}
                                icon={"pencil"}
                                disabled={!canEdit}
                                onClick={onUpdate}
                            />
                        }
                        {client.DELETE_faq(faq).canExecute() &&
                            <DeleteButton
                                label={t("FAQ:DELETE")}
                                confirmLabel={t("GLOBAL:CONFIRM")}
                                disabled={!canEdit}
                                requireConfirmation={true}
                                onClick={onDelete}
                            />
                        }
                        {!client.PATCH_faq(faq).canExecute() && !client.DELETE_faq(faq).canExecute() &&
                            t('FAQ:NO_RIGHTS')
                        }
                    </div>
                </Table.Cell>
            </tr>
        );
    }
}

export default FaqRow;



// WEBPACK FOOTER //
// ./src/views/AdminView/FaqTab/FaqRow.tsx